import React, { useState } from "react";
import { FaWhatsapp, FaLinkedin, FaTiktok, FaInstagram } from "react-icons/fa";
import emailjs from "@emailjs/browser";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .sendForm("service_77uejgm", "bwanakweli4ever", e.target, "T0pFpR16bzX1qUc5n")
      .then(() => {
        alert("Message sent successfully!");
        setFormData({ name: "", email: "", phone: "", message: "" });
      })
      .catch(() => alert("Error: message not sent."));
  };

  return (
    <main className="bg-cream pt-24">
      <section className="bg-espresso px-5 py-16 text-center text-cream md:px-8">
        <p className="eyebrow text-gold-soft">Get in Touch</p>
        <h1 className="mt-3 font-display text-4xl md:text-5xl">Contact & Wholesale</h1>
        <p className="mx-auto mt-4 max-w-xl text-cream/75">
          Orders, café partnerships, and wholesale inquiries—we&apos;d love to hear from you.
        </p>
      </section>

      <section className="section-pad">
        <div className="mx-auto grid max-w-6xl gap-10 lg:grid-cols-2">
          <form onSubmit={handleSubmit} className="rounded-2xl bg-white p-6 md:p-8">
            {[
              { id: "name", label: "Name", type: "text" },
              { id: "phone", label: "Phone", type: "tel" },
              { id: "email", label: "Email", type: "email" },
            ].map((field) => (
              <div key={field.id} className="mb-4">
                <label htmlFor={field.id} className="mb-1 block text-sm font-medium text-espresso">
                  {field.label}
                </label>
                <input
                  type={field.type}
                  id={field.id}
                  name={field.id}
                  value={formData[field.id]}
                  onChange={handleChange}
                  required
                  className="w-full rounded-lg border border-cream-muted bg-cream px-4 py-3 outline-none focus:border-gold"
                />
              </div>
            ))}
            <div className="mb-6">
              <label htmlFor="message" className="mb-1 block text-sm font-medium text-espresso">
                Message
              </label>
              <textarea
                id="message"
                name="message"
                rows="5"
                value={formData.message}
                onChange={handleChange}
                required
                className="w-full rounded-lg border border-cream-muted bg-cream px-4 py-3 outline-none focus:border-gold"
              />
            </div>
            <button type="submit" className="btn-primary w-full">
              Send Message
            </button>
          </form>

          <div className="space-y-6">
            <div className="rounded-2xl bg-cream-warm p-6">
              <h2 className="font-display text-2xl text-espresso">Visit & Call</h2>
              <ul className="mt-4 space-y-3 text-cocoa">
                <li>KG 182 Street, Kigali, Rwanda</li>
                <li>
                  <a href="tel:+250787255672" className="hover:text-gold">
                    +250 787 255 672
                  </a>
                </li>
                <li>
                  <a href="tel:+250795019523" className="hover:text-gold">
                    +250 795 019 523
                  </a>
                </li>
                <li>
                  <a href="mailto:info@kblcoffee.com" className="hover:text-gold">
                    info@kblcoffee.com
                  </a>
                </li>
              </ul>
            </div>

            <div className="rounded-2xl bg-espresso p-6 text-cream">
              <h2 className="font-display text-2xl text-gold">Order on WhatsApp</h2>
              <p className="mt-3 text-sm text-cream/75">
                Prefer a quick order? Message us directly and we&apos;ll help you choose size,
                grind, and delivery.
              </p>
              <a
                href="https://wa.me/250787255672"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-gold mt-5 inline-flex gap-2"
              >
                <FaWhatsapp /> Chat on WhatsApp
              </a>
            </div>

            <div className="flex gap-4 text-2xl text-espresso">
              <a href="https://www.instagram.com/kbl.coffee/" target="_blank" rel="noopener noreferrer" className="hover:text-gold" aria-label="Instagram">
                <FaInstagram />
              </a>
              <a href="https://www.tiktok.com/@kbl.coffee" target="_blank" rel="noopener noreferrer" className="hover:text-gold" aria-label="TikTok">
                <FaTiktok />
              </a>
              <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer" className="hover:text-gold" aria-label="LinkedIn">
                <FaLinkedin />
              </a>
              <a href="https://wa.me/250787255672" target="_blank" rel="noopener noreferrer" className="hover:text-gold" aria-label="WhatsApp">
                <FaWhatsapp />
              </a>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Contact;
